
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/european-architecture-castle-terminology",
      function () {
        return require("private-next-pages/articles/european-architecture-castle-terminology.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/european-architecture-castle-terminology"])
      });
    }
  